import { useState } from "react";
import { useFormik } from "formik";
import { useSelector } from "react-redux";

import endpoints from "../../api/endpoints";
import usePutApi from "../../hooks/use-put-api";
import { ITransactionPwdPayload } from "../../types";
import ShowTransactionPassword from "./show-transaction-password";
import { changePasswordSchema } from "../../utils/validation-schema";
import { showErrorToast } from "src/utils/toast";
import { RootState } from "../../redux/store";

const ChangePasswordForm = () => {
  const userId = useSelector((state: RootState) => state.user.userData?.user_id ?? "");

  const [created, setCreated] = useState<string>("");

  const { error, putData } = usePutApi<any, ITransactionPwdPayload>(
    endpoints.ACCOUNT.get_transaction_pwd(userId)
  );

  const { values, touched, errors, handleChange, handleSubmit, handleBlur } = useFormik({
    initialValues: {
      password: "",
      confirm_password: "",
      transaction_password: "",
    },
    onSubmit: (formValues) => {
      handle.createTransactionPwd(formValues);
    },
    validationSchema: changePasswordSchema,
  });

  const handle = {
    createTransactionPwd: (formData: ITransactionPwdPayload) => {
      putData(formData)
        .then((res) => {
          const transaction_password = res?.data?.data?.transaction_password;

          if (transaction_password) {
            setCreated(transaction_password);
          }
        })
        .catch(() => {
          if (error) {
            console.log("error", error);
            const message = (error as any)?.data?.status_message || "Something went wrong";
            showErrorToast(message);
          }
        });
    },
  };

  if (created) {
    return <ShowTransactionPassword password={created} />;
  }

  return (
    <div>
      <div className="listing-grid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <h4 className="mb-0 font-size-18">Change Password</h4>
              <div className="page-title-right">&nbsp;</div>
            </div>
          </div>
        </div>

        <div className="col-12">
          <div className="row mt-3">
            <div className="col-4">
              <form onSubmit={handleSubmit} method="post">
                <div className="form-group">
                  <label htmlFor="password">New Password</label>
                  <input
                    id="password"
                    type="password"
                    name="password"
                    className={`form-control${touched.password && errors.password ? " is-invalid" : ""}`}
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.password && errors.password && (
                    <small className="error">{errors.password}</small>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="confirm_password">Confirm Password</label>
                  <input
                    id="confirm_password"
                    type="password"
                    name="confirm_password"
                    className={`form-control${touched.confirm_password && errors.confirm_password ? " is-invalid" : ""}`}
                    value={values.confirm_password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.confirm_password && errors.confirm_password && (
                    <small className="error">{errors.confirm_password}</small>
                  )}
                </div>

                <div className="form-group">
                  <label htmlFor="transaction_password">Transaction Password</label>
                  <input
                    id="transaction_password"
                    type="password"
                    name="transaction_password"
                    className={`form-control${touched.transaction_password && errors.transaction_password ? " is-invalid" : ""}`}
                    value={values.transaction_password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.transaction_password && errors.transaction_password && (
                    <small className="error">{errors.transaction_password}</small>
                  )}
                </div>

                <div className="form-group">
                  <button type="submit" className="btn btn-primary">
                    Load
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
